// extracted by mini-css-extract-plugin
export var small = "typography-module--small--2nyk3";
export var xlp = "typography-module--xlp--1TM4W";
export var lp = "typography-module--lp--36nrO";
export var bodyheading = "typography-module--bodyheading--3izXh";
export var muted = "typography-module--muted--3F7Og";
export var textCenter = "typography-module--textCenter--1LS2_";
export var emphasis = "typography-module--emphasis--3Kdw2";